import { ApiModel } from '@composable-api/api.model'

interface Attributes {
    [ItemProductFieldModel.ATTR_CART_ITEM_ID]: number | undefined
    [ItemProductFieldModel.ATTR_CREATED_AT]: string
    [ItemProductFieldModel.ATTR_ID]: number
    [ItemProductFieldModel.ATTR_NAME]: string | undefined
    [ItemProductFieldModel.ATTR_ORDER_ITEM_ID]: number | undefined
    [ItemProductFieldModel.ATTR_PRODUCT_FIELD_ID]: number
    [ItemProductFieldModel.ATTR_UPDATED_AT]: string
    [ItemProductFieldModel.ATTR_VALUE]: any
}

interface Embeds {
    [ItemProductFieldModel.EMBED_PRODUCT_FIELD]: ProductField
}

export class ItemProductFieldModel extends ApiModel<Attributes, Embeds> {
    static key = 'ItemProductFieldModel'

    static readonly ATTR_CART_ITEM_ID = 'cart_item_id'
    static readonly ATTR_CREATED_AT = 'created_at'
    static readonly ATTR_ID = 'id'
    static readonly ATTR_NAME = 'name'
    static readonly ATTR_ORDER_ITEM_ID = 'order_item_id'
    static readonly ATTR_PRODUCT_FIELD_ID = 'product_field_id'
    static readonly ATTR_UPDATED_AT = 'updated_at'
    static readonly ATTR_VALUE = 'value'

    static readonly EMBED_PRODUCT_FIELD = 'product_field'

    get cartItemId() {
        return this._getAttribute(ItemProductFieldModel.ATTR_CART_ITEM_ID)
    }
    get createdAt() {
        return this._getAttribute(ItemProductFieldModel.ATTR_CREATED_AT)
    }
    get id() {
        return this._getAttribute(ItemProductFieldModel.ATTR_ID)
    }
    get name() {
        return this._getAttribute(ItemProductFieldModel.ATTR_NAME)
    }
    get orderItemId() {
        return this._getAttribute(ItemProductFieldModel.ATTR_ORDER_ITEM_ID)
    }
    get productFieldId() {
        return this._getAttribute(ItemProductFieldModel.ATTR_PRODUCT_FIELD_ID)
    }
    get updatedAt() {
        return this._getAttribute(ItemProductFieldModel.ATTR_UPDATED_AT)
    }
    get value() {
        return this._getAttribute(ItemProductFieldModel.ATTR_VALUE)
    }

    get productField() {
        return this._getEmbed(ItemProductFieldModel.EMBED_PRODUCT_FIELD)
    }
}

interface ProductField {
    name: string,
    id: number,
}
